/** Reads live QuantisAI prose and the final validated response envelope. */
import { readEventStream } from '../quantis-ai/eventStream';
export type QuantisAIActivity = 'compacting_context' | 'thinking';
export async function readQuantisAIReply<T>(response: Response, onText: (text: string) => void, signal?: AbortSignal,
  onActivity?: (phase: QuantisAIActivity) => void): Promise<{ status: number; value: T }> {
  if (!response.headers?.get('content-type')?.includes('text/event-stream')) return { status: response.status, value: await response.json() as T };
  let text = '', completed: { status: number; value: T } | null = null;
  await readEventStream(response, event => {
    const value = JSON.parse(event.data) as Record<string, unknown>;
    if (event.event === 'text_delta') {
      if (typeof value.delta !== 'string' || text.length + value.delta.length > 65_536) throw new Error('Invalid QuantisAI reply stream.');
      text += value.delta; onText(text);
    } else if (event.event === 'activity') {
      if (value.phase === 'compacting_context' || value.phase === 'thinking') onActivity?.(value.phase);
    } else if (event.event === 'reply_reset') { text = ''; onText(''); }
    else if (event.event === 'complete') {
      if (!Number.isInteger(value.status) || Number(value.status) < 200 || Number(value.status) > 599 || !value.result || typeof value.result !== 'object' || Array.isArray(value.result))
        throw new Error('Invalid QuantisAI completion.');
      completed = { status: Number(value.status), value: value.result as T };
      return false;
    }
  }, signal);
  if (!completed) throw new Error('QuantisAI stopped before completing its reply.');
  return completed;
}
